import { render, staticRenderFns } from "./checkmark.vue?vue&type=template&id=0b64624c&scoped=true&"
var script = {}
import style0 from "./checkmark.vue?vue&type=style&index=0&id=0b64624c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b64624c",
  null
  
)

export default component.exports